module.exports = __webpack_public_path__ + "static/media/user.7343b08b.svg";